$(document).ready(() => {
    $('.map-link ').click(e => {
        $('#map-area').empty().html($(e.currentTarget).attr('data-map'));
    });
});



/** WEBPACK FOOTER **
 ** ./src/javascripts/pages/gigs.es6
 **/